// PaymentStatusBadge — DRY: one payment-status pill, reused wherever enrollments are listed.
import Badge from "./Badge.js";
import type { PaymentStatus } from "@dm-lms/shared/types";

const TONE_BY_STATUS: Record<PaymentStatus, "green" | "gold" | "red"> = {
  paid:    "green",
  partial: "gold",
  pending: "red",
};

export default function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
  return <Badge tone={TONE_BY_STATUS[status]}>{status}</Badge>;
}
